import _ from "lodash";
import client from "lib/apolloClient/client";
import { getAIAnalysisScaleEvaluationQuery } from "./AITutorAnalysisQueries";

export const getAIAnalysisScaleEvaluation = async variables => {
  try {
    const response = await client.query({
      query: getAIAnalysisScaleEvaluationQuery,
      variables,
      fetchPolicy: "network-only",
    });

    return _.get(response, "data.node", {});
  } catch (error) {
    return {};
  }
};
